import { Card, Typography } from '@mui/material';

const PartCard = ({ part, onClick }) => {
  return (
    <Card
      variant="outlined"
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        '&:hover': { boxShadow: 1 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        p: 2
      }}
    >
      <Typography variant="h6" sx={{ textAlign: 'center' }}>
        {part.name}
      </Typography>
    </Card>
  );
};

export default PartCard;
